import React, {useEffect} from "react";
import {useStyles} from "./styles/PushStyle";
import {
    Box,
    TablePagination,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Button,
    Typography
} from "@material-ui/core";
import PropTypes from 'prop-types';
import {DATE_UTIL} from "../../../common/util/date/date.util";
import {ReactComponent as AlignLeftIcon} from '../../../common/images/AlignLeftIcon.svg';
import {ReactComponent as TextFieldDownIcon} from '../../../common/images/TextFieldDownIcon.svg';
import {ReactComponent as TableSortIcon} from '../../../common/images/TableSortIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {useHistory} from "react-router-dom";
import {PushStatusType, PushType} from "../../../stores/PushStore";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function PushHome(props) {
    const classes = useStyles();
    const history = useHistory();
    const {authStore, pushStore, localeStore} = props;
    const {intl} = props;

    useEffect(() => {
        pushStore.getPushes(authStore.loginUser.id, localeStore.locale);
        pushStore.setSortColumn("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangePage = (event, newPage) => {
        pushStore.setPage(newPage, authStore.loginUser.id, localeStore.locale);
    };

    const handleChangeRowsPerPage = (event) => {
        pushStore.setRowsPerPage(parseInt(event.target.value, 10), authStore.loginUser.id, localeStore.locale);
    };

    const handleClickCreatedDateSort = () => {
        if (pushStore.sortColumn === 'register_date') {
            pushStore.setIsAscending(!pushStore.isAscending);
        } else {
            pushStore.setSortColumn('register_date');
            pushStore.setIsAscending(false);
        }
        pushStore.getPushes(authStore.loginUser.id, localeStore.locale);
    };

    const handelClickManage = (pushId) => {
        history.push(`/push/${pushId}/lang/${localeStore.locale.toUpperCase()}`);
    }

    function formatTime(timeString) {
        const date = new Date(timeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    }

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"flex-end"}>
                <Box marginRight={2} marginBottom={2}>
                    <Button className={classes.tableButton2} disableRipple
                            onClick={() => handelClickManage(0)}>{intl.formatMessage({id: "written"})}</Button>
                </Box>
            </Box>
            <Box>
                <Box>
                    <TableContainer className={classes.tableBox}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead className={classes.tableHeadStyle}>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{minWidth: 55}}
                                    >
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{"No"}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "type"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "title"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "subTitle"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "reservation_delivery_time"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" onClick={handleClickCreatedDateSort}
                                               style={{minWidth: 55}}>
                                        <Box className={classes.sortButton}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "register_date"})}</Typography>
                                            {pushStore.sortColumn === 'register_date' &&
                                                (pushStore.isAscending ?
                                                    <TableSortIcon style={{transform: 'scaleY(-1)'}}/> :
                                                    <TableSortIcon/>)
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tableBodyStyle}>
                                {pushStore.pushList.map((push, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row"
                                                   align='left'>{index + (pushStore.page * pushStore.rowsPerPage) + 1}</TableCell>
                                        {push.pushType === PushType.Group ? (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${push.pushType}`})}({intl.formatMessage({id: `${push.localeCode}`})} - {push.localeGroupName})
                                                    </Typography>
                                                </TableCell>
                                            ) :
                                            push.pushType === PushType.Locale ? (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${push.pushType}`})}({intl.formatMessage({id: `${push.localeCode}`})})
                                                    </Typography>
                                                </TableCell>
                                            ) : (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${push.pushType}`})}
                                                    </Typography>
                                                </TableCell>
                                            )}
                                        <TableCell align="left">{push.title}</TableCell>
                                        <TableCell align="left">{push.subTitle}</TableCell>
                                        <TableCell align="left">
                                            <Box display={"flex"} flexDirection={"row"}>
                                                <Box marginRight={0.5}>
                                                    <Typography>{!!push.reservationDatetime ? formatTime(push.reservationDatetime) : formatTime(push.createdDatetime)}</Typography>
                                                </Box>
                                                {push.status === PushStatusType.Wait ? (
                                                    <Box>
                                                        <Typography style={{color: "#056CF2"}}>{`(${intl.formatMessage({id: "Reserve"})})`}</Typography>
                                                    </Box>
                                                ) : push.status === PushStatusType.Progress && (
                                                    <Box>
                                                        <Typography style={{color: "#056CF2"}}>{`(${intl.formatMessage({id: "sending"})})`}</Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </TableCell>
                                        <TableCell
                                            align="left">{DATE_UTIL.getTimeZoneDate(push.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                        <TableCell align="center">
                                            <Button className={classes.tableButton} disableRipple
                                                    onClick={() => handelClickManage(push.id)}
                                                    disabled={push.status === PushStatusType.Completed}
                                                    style={{color: 'white', backgroundColor: push.status === PushStatusType.Completed ? 'gray' : '#5579F0'}}>{intl.formatMessage({id: "management"})}</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 15, 20]}
                        count={pushStore.totalCount}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                        page={pushStore.page}
                        rowsPerPage={pushStore.rowsPerPage}
                        component="div"
                        labelDisplayedRows={({count, page}) => {
                            return <span
                                className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / pushStore.rowsPerPage)}</span>
                        }}
                        SelectProps={{
                            IconComponent: TextFieldDownIcon,
                            MenuProps: {
                                className: classes.selectPopover
                            }
                        }}
                        className={classes.paginationBox}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default inject('authStore', 'pushStore', 'localeStore')(injectIntl(observer(PushHome)));